import { CURRENCIES } from "@/data/schemas";

// https://frequentmiler.com/reasonable-redemption-values-rrvs/
export const FREQUENT_MILER_VALUATIONS: { [name: string]: number } = {
  // Hotels
  [CURRENCIES.HYATT]: 1.6,
  [CURRENCIES.WYNDHAM]: 0.82,
  [CURRENCIES.HILTON]: 0.4,
  [CURRENCIES.IHG]: 0.6,
  [CURRENCIES.MARRIOTT]: 0.75,

  // Airlines
  [CURRENCIES.AEROPLAN]: 1.3,
  [CURRENCIES.ALASKA]: 1.3,
  [CURRENCIES.AMERICAN]: 1.3,
  [CURRENCIES.AVIANCA]: 1.3,
  [CURRENCIES.AVIOS]: 1.09,
  [CURRENCIES.CATHAY_PACIFIC]: 1.09,
  [CURRENCIES.DELTA]: 1.2,
  [CURRENCIES.FRONTIER]: 0.95,
  [CURRENCIES.HAWAIIAN]: 0.75,
  [CURRENCIES.JETBLUE]: 1.33,
  [CURRENCIES.KOREAN]: 1.3,
  [CURRENCIES.LATAM]: 0.62,
  [CURRENCIES.LUFTHANSA]: 1.3,
  [CURRENCIES.SOUTHWEST]: 1.4,
  [CURRENCIES.UNITED]: 1.3,
  [CURRENCIES.VIRGIN]: 1.3,

  // Transferable
  [CURRENCIES.AMERICAN_EXPRESS]: 1.55,
  [CURRENCIES.BILT]: 1.55,
  [CURRENCIES.BREX]: 1.4,
  [CURRENCIES.CHASE]: 1.5,
  [CURRENCIES.CITI]: 1.45,
  [CURRENCIES.CAPITAL_ONE]: 1.45,

  // Other
  [CURRENCIES.US_BANK]: 1,
  [CURRENCIES.WELLS_FARGO]: 1,
  [CURRENCIES.DISCOVER]: 1,
  [CURRENCIES.BARCLAYS]: 1,
};

export const DIRECT_CASHBACK_VALUATIONS: { [name: string]: number } = {
  [CURRENCIES.CHASE]: 1,
  [CURRENCIES.AMERICAN_EXPRESS]: 0.6,
  [CURRENCIES.BANK_OF_AMERICA]: 1,
  [CURRENCIES.BARCLAYS]: 1,
  [CURRENCIES.BREX]: 1,
  [CURRENCIES.CAPITAL_ONE]: 1,
  [CURRENCIES.CITI]: 1,
  [CURRENCIES.DISCOVER]: 1,
  [CURRENCIES.US_BANK]: 1,
  [CURRENCIES.WELLS_FARGO]: 1,
  [CURRENCIES.USD]: 100,
};

export const NERDWALLET_TRANSFERABLE_VALUATIONS: { [name: string]: number } = {
  [CURRENCIES.AMERICAN_EXPRESS]: 2,
  [CURRENCIES.BANK_OF_AMERICA]: 1,
  [CURRENCIES.BARCLAYS]: 1,
  [CURRENCIES.CAPITAL_ONE]: 1.8,
  [CURRENCIES.CHASE]: 1.85,
  [CURRENCIES.CITI]: 1.5,
  [CURRENCIES.DISCOVER]: 1,
  [CURRENCIES.US_BANK]: 1,
  [CURRENCIES.WELLS_FARGO]: 1.5,
};

// https://www.nerdwallet.com/article/travel/airline-miles-and-hotel-points-valuations
export const NERDWALLET_ECONOMY_VALUATIONS: { [name: string]: number } = {
  // Hotels + Airlines
  [CURRENCIES.AEROPLAN]: 1.9,
  [CURRENCIES.FLYING_BLUE]: 1.4,
  [CURRENCIES.ALASKA]: 1.1,
  [CURRENCIES.AMERICAN]: 1.2,
  [CURRENCIES.ANA]: 2,
  [CURRENCIES.BEST_WESTERN]: 0.7,
  [CURRENCIES.AVIOS]: 0.8,
  [CURRENCIES.DELTA]: 1.3,
  [CURRENCIES.EMIRATES]: 1,
  [CURRENCIES.FRONTIER]: 0.7,
  [CURRENCIES.HAWAIIAN]: 1,
  [CURRENCIES.HILTON]: 0.5,
  [CURRENCIES.HYATT]: 1.9,
  [CURRENCIES.IHG]: 0.8,
  [CURRENCIES.JETBLUE]: 1.5,
  [CURRENCIES.MARRIOTT]: 0.7,
  [CURRENCIES.RADISSON]: 0.6,
  [CURRENCIES.SOUTHWEST]: 1.4,
  [CURRENCIES.SPIRIT]: 1.1,
  [CURRENCIES.UNITED]: 1,
  [CURRENCIES.VIRGIN]: 1.1,
  [CURRENCIES.WYNDHAM]: 0.9,
};

// https://www.nerdwallet.com/article/travel/airline-miles-and-hotel-points-valuations
export const NERDWALLET_BUSINESS_VALUATIONS: { [name: string]: number } = {
  // Hotels + Airlines
  [CURRENCIES.AEROPLAN]: 2.7,
  [CURRENCIES.FLYING_BLUE]: 1.8,
  [CURRENCIES.ALASKA]: 2.8,
  [CURRENCIES.AMERICAN]: 2.5,
  [CURRENCIES.ANA]: 7.4,
  [CURRENCIES.AVIOS]: 1.9,
  [CURRENCIES.DELTA]: 1.5,
  [CURRENCIES.EMIRATES]: 3,
  [CURRENCIES.HAWAIIAN]: 2.4,
  [CURRENCIES.UNITED]: 2.4,
  [CURRENCIES.VIRGIN]: 2.1,
};

// TODO: Figure out how to do this in a way that's type-comprehensive
export const DEFAULT_VALUATIONS: Record<string, number> = {
  // Hotels
  [CURRENCIES.BEST_WESTERN]: 0.56,
  [CURRENCIES.HILTON]: 0.47,
  [CURRENCIES.HYATT]: 1.56,
  [CURRENCIES.IHG]: 0.5,
  [CURRENCIES.MARRIOTT]: 0.7,
  [CURRENCIES.RADISSON]: 0.33,
  [CURRENCIES.WYNDHAM]: 0.89,
  [CURRENCIES.CHOICE]: 0.6,

  // Airlines
  [CURRENCIES.AEROPLAN]: 1.44,
  [CURRENCIES.ALASKA]: 1.69,
  [CURRENCIES.AMERICAN]: 1.47,
  [CURRENCIES.ANA]: 1.44,
  [CURRENCIES.AVIANCA]: 1.41,
  [CURRENCIES.AVIOS]: 1.09,
  [CURRENCIES.BREEZE]: 1.0,
  [CURRENCIES.CATHAY_PACIFIC]: 1.25,
  [CURRENCIES.DELTA]: 1.17,
  [CURRENCIES.EMIRATES]: 1.18,
  [CURRENCIES.FRONTIER]: 1.05,
  [CURRENCIES.FLYING_BLUE]: 1.24,
  [CURRENCIES.HAWAIIAN]: 0.85,
  [CURRENCIES.JETBLUE]: 1.32,
  [CURRENCIES.KOREAN]: 1.5,
  [CURRENCIES.LUFTHANSA]: 1.28,
  [CURRENCIES.SOUTHWEST]: 1.33,
  [CURRENCIES.SPIRIT]: 1.1,
  [CURRENCIES.UNITED]: 1.3,
  [CURRENCIES.VIRGIN]: 1.32,

  // Transferable
  [CURRENCIES.AMERICAN_EXPRESS]: 1.69,
  [CURRENCIES.BANK_OF_AMERICA]: 1,
  [CURRENCIES.BARCLAYS]: 1.02,
  [CURRENCIES.BILT]: 1.71,
  [CURRENCIES.BREX]: 1.43,
  [CURRENCIES.CHASE]: 1.72,
  [CURRENCIES.CITI]: 1.54,
  [CURRENCIES.CAPITAL_ONE]: 1.51,
  [CURRENCIES.DISCOVER]: 1,
  [CURRENCIES.US_BANK]: 1,
  [CURRENCIES.WELLS_FARGO]: 1,
  [CURRENCIES.LATAM]: 0.62,

  [CURRENCIES.CARNIVAL]: 1,
  [CURRENCIES.EXPEDIA]: 1,
  [CURRENCIES.AMTRAK]: 2,
  [CURRENCIES.PENFED]: 0.95,

  [CURRENCIES.USD]: 100,
};

export const ABBREVIATIONS: { [p: string]: string } = {
  [CURRENCIES.BEST_WESTERN]: "Best Western",
  [CURRENCIES.HILTON]: "Hilton",
  [CURRENCIES.HYATT]: "Hyatt",
  [CURRENCIES.IHG]: "IHG",
  [CURRENCIES.MARRIOTT]: "Marriott",
  [CURRENCIES.RADISSON]: "Radisson",
  [CURRENCIES.WYNDHAM]: "Wyndham",
  [CURRENCIES.CHOICE]: "Choice",

  // Airlines
  [CURRENCIES.AEROPLAN]: "Aeroplan",
  [CURRENCIES.ALASKA]: "Alaska",
  [CURRENCIES.AMERICAN]: "AA",
  [CURRENCIES.ANA]: "ANA",
  [CURRENCIES.AVIANCA]: "Avianca",
  [CURRENCIES.AVIOS]: "Avios",
  [CURRENCIES.CATHAY_PACIFIC]: "Cathay Pacific",
  [CURRENCIES.DELTA]: "Delta",
  [CURRENCIES.EMIRATES]: "Emirates",
  [CURRENCIES.FRONTIER]: "Frontier",
  [CURRENCIES.FLYING_BLUE]: "Flying Blue",
  [CURRENCIES.HAWAIIAN]: "Hawaiian",
  [CURRENCIES.JETBLUE]: "Jetblue",
  [CURRENCIES.KOREAN]: "Korean",
  [CURRENCIES.LUFTHANSA]: "Lufthansa",
  [CURRENCIES.SOUTHWEST]: "Southwest",
  [CURRENCIES.SPIRIT]: "Spirit",
  [CURRENCIES.UNITED]: "United",
  [CURRENCIES.VIRGIN]: "Virgin",

  // Transferable
  [CURRENCIES.AMERICAN_EXPRESS]: "Amex",
  [CURRENCIES.BANK_OF_AMERICA]: "Bank of America",
  [CURRENCIES.BARCLAYS]: "Barclays",
  [CURRENCIES.BILT]: "Bilt",
  [CURRENCIES.BREX]: "Brex",
  [CURRENCIES.CHASE]: "Chase",
  [CURRENCIES.CITI]: "Citi",
  [CURRENCIES.CAPITAL_ONE]: "Capital One",
  [CURRENCIES.DISCOVER]: "Discover",
  [CURRENCIES.US_BANK]: "US Bank",
  [CURRENCIES.WELLS_FARGO]: "Wells Fargo",
  [CURRENCIES.LATAM]: "LATAM",

  [CURRENCIES.CARNIVAL]: "Carnival",
  [CURRENCIES.AMTRAK]: "Amtrak",
  [CURRENCIES.PENFED]: "PenFed",

  [CURRENCIES.USD]: "USD",
};

const getAverageValue = (currency: string) => {
  let average = 0;
  let numberFound = 0;
  if (FREQUENT_MILER_VALUATIONS[currency]) {
    average += FREQUENT_MILER_VALUATIONS[currency] as number;
    numberFound++;
  }
  if (NERDWALLET_TRANSFERABLE_VALUATIONS[currency]) {
    average += NERDWALLET_TRANSFERABLE_VALUATIONS[currency] as number;
    numberFound++;
  }
  if (NERDWALLET_ECONOMY_VALUATIONS[currency]) {
    average += NERDWALLET_ECONOMY_VALUATIONS[currency] as number;
    numberFound++;
  }
  if (NERDWALLET_BUSINESS_VALUATIONS[currency]) {
    average += NERDWALLET_BUSINESS_VALUATIONS[currency] as number;
    numberFound++;
  }
  if (DEFAULT_VALUATIONS[currency]) {
    average += DEFAULT_VALUATIONS[currency] as number;
    numberFound++;
  }
  if (average === 0) {
    console.warn(
      `Defaulting to 1cpp for currency ${currency} because it wasn't found in any valuation maps.`,
    );
    average += 1;
    numberFound += 1;
  }
  return average / numberFound;
};

export const AVERAGE_VALUES: { [name: string]: number } = {
  // Hotels
  [CURRENCIES.BEST_WESTERN]: getAverageValue(CURRENCIES.BEST_WESTERN),
  [CURRENCIES.HILTON]: getAverageValue(CURRENCIES.HILTON),
  [CURRENCIES.HYATT]: getAverageValue(CURRENCIES.HYATT),
  [CURRENCIES.IHG]: getAverageValue(CURRENCIES.IHG),
  [CURRENCIES.MARRIOTT]: getAverageValue(CURRENCIES.MARRIOTT),
  [CURRENCIES.RADISSON]: getAverageValue(CURRENCIES.RADISSON),
  [CURRENCIES.WYNDHAM]: getAverageValue(CURRENCIES.WYNDHAM),

  // Airlines
  [CURRENCIES.AEROPLAN]: getAverageValue(CURRENCIES.AEROPLAN),
  [CURRENCIES.ALASKA]: getAverageValue(CURRENCIES.ALASKA),
  [CURRENCIES.AMERICAN]: getAverageValue(CURRENCIES.AMERICAN),
  [CURRENCIES.ANA]: getAverageValue(CURRENCIES.ANA),
  [CURRENCIES.AVIANCA]: getAverageValue(CURRENCIES.AVIANCA),
  [CURRENCIES.AVIOS]: getAverageValue(CURRENCIES.AVIOS),
  [CURRENCIES.BREEZE]: getAverageValue(CURRENCIES.BREEZE),
  [CURRENCIES.CATHAY_PACIFIC]: getAverageValue(CURRENCIES.CATHAY_PACIFIC),
  [CURRENCIES.DELTA]: getAverageValue(CURRENCIES.DELTA),
  [CURRENCIES.EMIRATES]: getAverageValue(CURRENCIES.EMIRATES),
  [CURRENCIES.FRONTIER]: getAverageValue(CURRENCIES.FRONTIER),
  [CURRENCIES.FLYING_BLUE]: getAverageValue(CURRENCIES.FLYING_BLUE),
  [CURRENCIES.HAWAIIAN]: getAverageValue(CURRENCIES.HAWAIIAN),
  [CURRENCIES.JETBLUE]: getAverageValue(CURRENCIES.JETBLUE),
  [CURRENCIES.KOREAN]: getAverageValue(CURRENCIES.KOREAN),
  [CURRENCIES.LATAM]: getAverageValue(CURRENCIES.LATAM),
  [CURRENCIES.LUFTHANSA]: getAverageValue(CURRENCIES.LUFTHANSA),
  [CURRENCIES.SOUTHWEST]: getAverageValue(CURRENCIES.SOUTHWEST),
  [CURRENCIES.SPIRIT]: getAverageValue(CURRENCIES.SPIRIT),
  [CURRENCIES.UNITED]: getAverageValue(CURRENCIES.UNITED),
  [CURRENCIES.VIRGIN]: getAverageValue(CURRENCIES.VIRGIN),

  // Transferable
  [CURRENCIES.AMERICAN_EXPRESS]: getAverageValue(CURRENCIES.AMERICAN_EXPRESS),
  [CURRENCIES.BANK_OF_AMERICA]: getAverageValue(CURRENCIES.BANK_OF_AMERICA),
  [CURRENCIES.BARCLAYS]: getAverageValue(CURRENCIES.BARCLAYS),
  [CURRENCIES.BILT]: getAverageValue(CURRENCIES.BILT),
  [CURRENCIES.BREX]: getAverageValue(CURRENCIES.BREX),
  [CURRENCIES.CHASE]: getAverageValue(CURRENCIES.CHASE),
  [CURRENCIES.CITI]: getAverageValue(CURRENCIES.CITI),
  [CURRENCIES.CAPITAL_ONE]: getAverageValue(CURRENCIES.CAPITAL_ONE),
  [CURRENCIES.DISCOVER]: getAverageValue(CURRENCIES.DISCOVER),
  [CURRENCIES.US_BANK]: getAverageValue(CURRENCIES.US_BANK),
  [CURRENCIES.WELLS_FARGO]: getAverageValue(CURRENCIES.WELLS_FARGO),

  [CURRENCIES.CARNIVAL]: 1,
  [CURRENCIES.AMTRAK]: 2,
  [CURRENCIES.PENFED]: getAverageValue(CURRENCIES.PENFED),
  [CURRENCIES.CHOICE]: getAverageValue(CURRENCIES.CHOICE),
};

// Source: https://docs.google.com/spreadsheets/d/1a4LMPBw9pQQuo89mZd3Ydo3TEcCzCK6rzYsaxuWIQ9c/edit#gid=474099669
